import NewLayout from "@components/new-ui/Layout";
import { CompanyTrustBanner } from "@components/Webinar/CompanyTrustBanner";
import IndividualWebinar, { IndividualWebinarProps } from "@components/Webinar/IndividualWebinar";

const HeroSectionData: IndividualWebinarProps = {
    title: "How Travel Brands Scale with WhatsApp Automation",
    listHeading: `Travelers today expect instant service, personalized attention, and seamless communication—right from their phones.\n
    In this exclusive webinar, discover how leading travel companies are using WhatsApp to elevate customer experiences, drive bookings, and reduce service bottlenecks.\n
    We'll break down the top use cases, showcase real examples, and give you a practical roadmap to get started with WhatsApp automation for your travel business.`,
    listText: [
        { label: "Why WhatsApp is the ultimate travel concierge" },
        { label: "How to automate booking flows, confirmations, and customer support" },
        { label: "Real-life success stories from travel brands using WhatsApp effectively" },
        { label: "Tools and strategies to launch your first WhatsApp travel campaign" },
    ],
    mediaUrl: "https://assets.gallabox.com/gb-home/webinar/webinar-6.png",
    speakerList: [
        {
            image: "/ranganayaki.png",
            name: "Ranganayaki R",
            role: "Whatsapp Evangelist",
        },
        {
            image: "/shoaib.png",
            name: "Shoaib Ahmed",
            role: "Growth Specialist",
        },
    ],
    youtubeURL: "https://youtu.be/7j0Z5Ry91Gk",
    inThisWebinar: "In this session, you’ll learn:",
    webinarSlug: "whatsapp-automation-for-travel-companies",
};

const Webinar: React.FC = () => {
    return (
        <NewLayout
            title="How Travel Companies Can Use WhatsApp Automation To Scale Their Businesses"
            description="Discover how top travel brands use WhatsApp to capture leads, send trip reminders, and drive bookings—at scale."
            canonical="https://gallabox.com/webinars/whatsapp-automation-for-travel-companies"
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/webinar/webinar-6.png" }}
        >
            <IndividualWebinar {...HeroSectionData} />
            <CompanyTrustBanner />
        </NewLayout>
    );
};

export default Webinar;
